(() => {
  if (window.__ylSupportContextReady) return;
  window.__ylSupportContextReady = true;
  const pendingKey = 'yl-contact-pending-fields';
  const plainValue = value => (value || '').replace(/[\x00-\x1f\x7f]/g, ' ').trim().slice(0, 120);
  function initialize() {
    const params = new URL(location.href).searchParams;
    const contact = document.querySelector('.yl-contact-form');
    if (contact && !contact.dataset.contextReady) {
      contact.dataset.contextReady = 'true';
      const model = contact.querySelector('[name="contact[model]"]');
      const topic = contact.querySelector('[name="contact[topic]"]');
      const fields = ['phone', 'topic', 'model', 'order_number'];
      let pending;
      try {
        pending = JSON.parse(sessionStorage.getItem(pendingKey) || 'null');
        sessionStorage.removeItem(pendingKey);
      } catch { /* Storage can be disabled; the form still works. */ }
      // Restore only after Shopify reports an error, and only for this tab.
      const pendingAge = typeof pending?.at === 'number' ? Date.now() - pending.at : NaN;
      if (contact.querySelector('.yl-form-errors') && pending
        && Number.isFinite(pendingAge) && pendingAge >= 0 && pendingAge < 10 * 60 * 1000) {
        for (const key of fields) {
          const input = contact.querySelector(`[name="contact[${key}]"]`);
          if (!input || input.value || typeof pending.values?.[key] !== 'string') continue;
          if (key === 'topic' && ![...input.options].some(option => option.value === pending.values[key])) continue;
          input.value = pending.values[key];
        }
      }
      contact.addEventListener('submit', () => {
        if (!contact.checkValidity()) return;
        const values = Object.fromEntries(fields.map(key => [key,
          contact.querySelector(`[name="contact[${key}]"]`)?.value || '']));
        // One-use tab storage holds structured fields, never the message.
        try { sessionStorage.setItem(pendingKey, JSON.stringify({ at: Date.now(), values })); }
        catch { /* Storage is optional. */ }
      });
      // URL context is plain editable text, never markup or an arbitrary topic option.
      if (model && !model.value) model.value = plainValue(params.get('model') || params.get('product'));
      const topics = { troubleshooting: 'Setup or troubleshooting', raedius: 'Raedius or business deployment' };
      if (topic && !topic.value) {
        if (topics[params.get('topic')]) topic.value = topics[params.get('topic')];
        else if (!params.has('topic') && plainValue(params.get('product'))) topic.value = 'Product selection';
      }
      const businessHelp = contact.querySelector('[data-yl-business-help]');
      const updateHelp = () => {
        if (businessHelp) businessHelp.hidden = Boolean(topic?.value) && topic.value !== topics.raedius;
      };
      topic?.addEventListener('change', updateHelp);
      updateHelp();
      contact.querySelector('[data-yl-form-message]')?.focus();
    }
    const raedius = document.querySelector('.yr');
    if (raedius && !raedius.dataset.contextReady) {
      raedius.dataset.contextReady = 'true';
      const intent = raedius.querySelector('[name="contact[request_intent]"]');
      const selectIntent = value => {
        if (!intent || !['trial', 'walkthrough'].includes(value)) return;
        intent.value = value;
        const url = new URL(location.href);
        url.searchParams.set('intent', value);
        history.replaceState(history.state, '', url);
      };
      selectIntent(params.get('intent'));
      raedius.querySelectorAll('[data-yr-intent]').forEach(link => {
        link.addEventListener('click', event => {
          if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          selectIntent(link.dataset.yrIntent);
          location.hash = 'raedius-contact';
          raedius.querySelector('#raedius-contact')?.scrollIntoView();
        });
      });
      intent?.addEventListener('change', () => selectIntent(intent.value));
      const feedback = raedius.querySelector('.yl-rd-form-message, .yl-rd-form-errors');
      if (feedback) {
        const focusFeedback = () => { if (feedback.isConnected) feedback.focus(); };
        // Native fragment navigation can move focus after DOMContentLoaded.
        if (location.hash && document.readyState !== 'complete') window.addEventListener('load', () => {
          const active = document.activeElement;
          const fragment = document.getElementById(location.hash.slice(1));
          // Do not interrupt a customer who already focused another control.
          if (active === document.body || active === fragment || active === feedback) focusFeedback();
        }, { once: true });
        else focusFeedback();
      }
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
